import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login')
    },
    {
      path: '/layout',
      component: () => import('@/pages/layout'),
      redirect: { name: 'index' },
      children: [{
        path: '/index',
        name: 'index',
        component: () => import('@/pages/index'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zixun/index',
        name: 'zixun/index',
        component: () => import('@/pages/zhiyuan/zixun/list'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/zixun/add',
        name: 'zixun/add',
        component: () => import('@/pages/zhiyuan/zixun/add'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/sub-account/statistic',
        name: 'sub-account/statistic',
        component: () => import('../pages/sub-account/statistic'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/xuanke/special-list/',
        name: 'xuanke/special-list',
        component: () => import('@/pages/xuanke/special/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/xuanke/special/:type',
        name: 'xuanke/special',
        component: () => import('@/pages/xuanke/special/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/xuanke/article-list/',
        name: 'xuanke/article-list',
        component: () => import('@/pages/xuanke/article/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/xuanke/article/:type',
        name: 'xuanke/article',
        component: () => import('@/pages/xuanke/article/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/xuanke/topic-list/',
        name: 'xuanke/topic-list',
        component: () => import('@/pages/xuanke/topic/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/xuanke/topic/:type',
        name: 'xuanke/topic',
        component: () => import('@/pages/xuanke/topic/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/special-list/:type',
        name: 'zhiyuan/special-list',
        component: () => import('@/pages/zhiyuan/special/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/special/:type',
        name: 'zhiyuan/special',
        component: () => import('@/pages/zhiyuan/special/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article-list/:type',
        name: 'zhiyuan/article-list',
        component: () => import('@/pages/zhiyuan/article/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article-list2/:type',
        name: 'zhiyuan/article-list2',
        component: () => import('@/pages/zhiyuan/article/list2'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article-list3/:type',
        name: 'zhiyuan/article-list3',
        component: () => import('@/pages/zhiyuan/article/list3'),
        meta: {
          requireAuth: true
        }

      }, {
        path: '/zhiyuan/article-list4/:type',
        name: 'zhiyuan/article-list4',
        component: () => import('@/pages/zhiyuan/article/list4'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article/:type',
        name: 'zhiyuan/article',
        component: () => import('@/pages/zhiyuan/article/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article2/:type',
        name: 'zhiyuan/article2',
        component: () => import('@/pages/zhiyuan/article/add2'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article3/:type',
        name: 'zhiyuan/article3',
        component: () => import('@/pages/zhiyuan/article/add3'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/article4/:type',
        name: 'zhiyuan/article4',
        component: () => import('@/pages/zhiyuan/article/add4'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/zhiyuan/article/special-list/:type',
        name: 'zhiyuan/article/special-list',
        component: () => import('@/pages/zhiyuan/article/special-list'),
        meta: {
          requireAuth: true
        }
      }, 
      {
        path: '/zhiyuan/article5/special-add/:type',
        name: 'zhiyuan/article5/special-add',
        component: () => import('@/pages/zhiyuan/article/special-add'),
        meta: {
          requireAuth: true
        }
      }, 
      {
        path: '/zhiyuan/banner-list/:type',
        name: 'zhiyuan/banner-list',
        component: () => import('@/pages/zhiyuan/banner/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/zhiyuan/banner/:type',
        name: 'zhiyuan/banner',
        component: () => import('@/pages/zhiyuan/banner/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/shengxue/banner/:type',
        name: 'shengxue/banner',
        component: () => import('@/pages/shengxue/banner/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/shengxue/banner-list/:type',
        name: 'shengxue/banner-list',
        component: () => import('@/pages/shengxue/banner/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/wxzy/banner-list/:type',
        name: 'wxzy/banner-list',
        component: () => import('@/pages/wxzy/banner/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/volunteer/card',
        name: 'volunteer/card',
        component: () => import('@/pages/volunteer/card'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/volunteer/use',
        name: 'volunteer/use',
        component: () => import('@/pages/volunteer/use'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/volunteer/report',
        name: 'volunteer/report',
        component: () => import('@/pages/volunteer/report'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/volunteer/manualActivation',
        name: 'volunteer/manualActivation',
        component: () => import('@/pages/volunteer/manualActivation'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/order/list',
        name: 'order/list',
        component: () => import('@/pages/order/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/order/mp-list',
        name: 'order/mp-list',
        component: () => import('@/pages/order/mp-list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/feedback/list',
        name: 'feedback/list',
        component: () => import('@/pages/feedback/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/counselorSubscribe/index',
        name: 'counselorSubscribe/index',
        component: () => import('@/pages/feedback/counselorSubscribe/index'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/toApplyFor/index',
        name: 'toApplyFor/index',
        component: () => import('@/pages/feedback/toApplyFor/index'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/memberManagement/index',
        name: 'memberManagement/index',
        component: () => import('@/pages/feedback/memberManagement/index'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/authority',
        name: 'system/authority',
        component: () => import('@/pages/system/authority'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/systemLog',
        name: 'system/systemLog',
        component: () => import('@/pages/system/systemLog'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/omsLog',
        name: 'system/omsLog',
        component: () => import('@/pages/system/omsLog'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/user-list',
        name: 'system/user-list',
        component: () => import('@/pages/system/user-list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/user/:type',
        name: 'system/user',
        component: () => import('@/pages/system/user'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/super-user',
        name: 'system/super-user',
        component: () => import('@/pages/system/super-user'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/app-list',
        name: 'system/app-list',
        component: () => import('@/pages/system/appAutoUpgrade'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/app',
        name: 'system/app',
        component: () => import('@/pages/system/app'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/organize-list',
        name: 'system/organize-list',
        component: () => import('@/pages/system/organize/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/dealer/list',
        name: 'dealer/list',
        component: () => import('@/pages/dealer/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/card/list',
        name: 'card/list',
        component: () => import('@/pages/card/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/card/use',
        name: 'card/use',
        component: () => import('@/pages/card/use'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/statistics/report',
        name: 'statistics/report',
        component: () => import('@/pages/statistics/report'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/list',
        name: 'activity/list',
        component: () => import('@/pages/activity/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/:type',
        name: 'activity',
        component: () => import('@/pages/activity/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/list',
        name: 'activity/day/list',
        component: () => import('@/pages/activity/day/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/detail',
        name: 'activity/day/detail',
        component: () => import('@/pages/activity/day/detail'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/addperson',
        name: 'activity/day/addperson',
        component: () => import('@/pages/activity/day/addperson'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/person',
        name: 'activity/day/person',
        component: () => import('@/pages/activity/day/person'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/student',
        name: 'activity/day/student',
        component: () => import('@/pages/activity/day/student'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/addstudent',
        name: 'activity/day/addstudent',
        component: () => import('@/pages/activity/day/addstudent'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/total',
        name: 'activity/day/total',
        component: () => import('@/pages/activity/day/total'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/activity/day/add',
        name: 'activity/day/add',
        component: () => import('@/pages/activity/day/add'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/agency/list',
        name: 'agency/list',
        component: () => import('@/pages/agency/list'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/agency/addagency',
        name: 'agency/addagency',
        component: () => import('@/pages/agency/addagency'),
        meta: {
          requireAuth: true
        }
      }, {
        path: '/agency/recharge',
        name: 'agency/recharge',
        component: () => import('@/pages/agency/recharge'),
        meta: {
          requireAuth: true
        }
      }
      ]
    }, {
      path: '/xuanke/special-list/',
      name: 'xuanke/special-list',
      component: () => import('@/pages/xuanke/special/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/xuanke/special/:type',
      name: 'xuanke/special',
      component: () => import('@/pages/xuanke/special/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/xuanke/article-list/',
      name: 'xuanke/article-list',
      component: () => import('@/pages/xuanke/article/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/xuanke/article/:type',
      name: 'xuanke/article',
      component: () => import('@/pages/xuanke/article/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/xuanke/topic-list/',
      name: 'xuanke/topic-list',
      component: () => import('@/pages/xuanke/topic/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/xuanke/topic/:type',
      name: 'xuanke/topic',
      component: () => import('@/pages/xuanke/topic/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/special-list/:type',
      name: 'zhiyuan/special-list',
      component: () => import('@/pages/zhiyuan/special/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/special/:type',
      name: 'zhiyuan/special',
      component: () => import('@/pages/zhiyuan/special/add'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/zhiyuan/article-list/:type',
      name: 'zhiyuan/article-list',
      component: () => import('@/pages/zhiyuan/article/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/article-list2/:type',
      name: 'zhiyuan/article-list2',
      component: () => import('@/pages/zhiyuan/article/list2'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/article/:type',
      name: 'zhiyuan/article',
      component: () => import('@/pages/zhiyuan/article/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/article2/:type',
      name: 'zhiyuan/article2',
      component: () => import('@/pages/zhiyuan/article/add2'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/banner-list/:type',
      name: 'zhiyuan/banner-list',
      component: () => import('@/pages/zhiyuan/banner/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/zhiyuan/banner/:type',
      name: 'zhiyuan/banner',
      component: () => import('@/pages/zhiyuan/banner/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/shengxue/banner/:type',
      name: 'shengxue/banner',
      component: () => import('@/pages/shengxue/banner/add'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/shengxue/banner-list/:type',
      name: 'shengxue/banner-list',
      component: () => import('@/pages/shengxue/banner/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/volunteer/card',
      name: 'volunteer/card',
      component: () => import('@/pages/volunteer/card'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/volunteer/use',
      name: 'volunteer/use',
      component: () => import('@/pages/volunteer/use'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/volunteer/report',
      name: 'volunteer/report',
      component: () => import('@/pages/volunteer/report'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/volunteer/manualActivation',
      name: 'volunteer/manualActivation',
      component: () => import('@/pages/volunteer/manualActivation'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/order/list',
      name: 'order/list',
      component: () => import('@/pages/order/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/feedback/list',
      name: 'feedback/list',
      component: () => import('@/pages/feedback/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/counselorSubscribe/index',
      name: 'counselorSubscribe/index',
      component: () => import('@/pages/feedback/counselorSubscribe/index'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/toApplyFor/index',
      name: 'toApplyFor/index',
      component: () => import('@/pages/feedback/toApplyFor/index'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/memberManagement/index',
      name: 'memberManagement/index',
      component: () => import('@/pages/feedback/memberManagement/index'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/authority',
      name: 'system/authority',
      component: () => import('@/pages/system/authority'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/systemLog',
      name: 'system/systemLog',
      component: () => import('@/pages/system/systemLog'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/omsLog',
      name: 'system/omsLog',
      component: () => import('@/pages/system/omsLog'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/user-list',
      name: 'system/user-list',
      component: () => import('@/pages/system/user-list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/user/:type',
      name: 'system/user',
      component: () => import('@/pages/system/user'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/super-user',
      name: 'system/super-user',
      component: () => import('@/pages/system/super-user'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/app-list',
      name: 'system/app-list',
      component: () => import('@/pages/system/appAutoUpgrade'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/app',
      name: 'system/app',
      component: () => import('@/pages/system/app'),
      meta: {
        requireAuth: true
      }
    }, {
      path: 'system/organize-list',
      name: 'system/organize-list',
      component: () => import('@/pages/system/organize/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/dealer/list',
      name: 'dealer/list',
      component: () => import('@/pages/dealer/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/card/list',
      name: 'card/list',
      component: () => import('@/pages/card/list'),
      meta: {
        requireAuth: true
      }
    }, {
      path: '/card/use',
      name: 'card/use',
      component: () => import('@/pages/card/use'),
      meta: {
        requireAuth: true
      }
    }, {
      path: 'statistics/report',
      name: 'statistics/report',
      component: () => import('@/pages/statistics/report'),
      meta: {
        requireAuth: true
      }
    }]
}

)



// WEBPACK FOOTER //
// ./src/router/index.js